// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Validation
import { Validator } from 'react-vld'
import { validateEqualStrings } from 'utils/validation'

// Actions
import { resetPassword } from 'actions/actions'

// Atoms
import CardContent from '@material-ui/core/CardContent'
import CardHeader from '@material-ui/core/CardHeader'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { LinkButton } from 'atoms/Link'
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import FormCard from 'atoms/FormCard'
import CenteredCard from 'atoms/CenteredCard'

const mapDispatchToProps = {
  resetPasswordAction: resetPassword
}

export default
@connect(null, mapDispatchToProps)
class ResetPasswordAction extends Component {
  static propTypes = {
    resetPasswordAction: PropTypes.func.isRequired,
    token: PropTypes.string,
  }

  state = {
    password: '',
    confirmPassword: '', // eslint-disable-line
    complete: false,
  }

  validateConfirmPassword = () => {
    const { value: password } = this.passwordField.state
    const { value: confirmPassword } = this.confirmPasswordField.state
    validateEqualStrings(password, confirmPassword, 'Passwords do not match')
  }

  handleSubmit = async (cancelToken) => {
    const { resetPasswordAction, token } = this.props
    const { password } = this.state
    await resetPasswordAction(token, password, cancelToken)
    this.setState({ complete: true })
  }

  handleFieldSave = fieldName => (value) => {
    this.setState({ [fieldName]: value })
  }

  // @todo
  handleEnterPress = fieldName => () => {
    if (fieldName === 'password') this.confirmPasswordInput.focus()
    if (fieldName === 'confirmPassword') this.handleSubmit()
  }

  passwordInnerRef = (input) => {
    this.passwordField = input
  }

  confirmPasswordInnerRef = (input) => {
    this.confirmPasswordField = input
  }

  confirmPasswordInputRef = (input) => {
    this.confirmPasswordInput = input
  }

  renderField(fieldName, props) {
    const { [fieldName]: value } = this.state
    return (
      <TextInput
        required
        minLength={6}
        withBorder
        type="password"
        placeholder="******"
        defaultValue={value}
        onSave={this.handleFieldSave(fieldName)}
        onEnterPress={this.handleEnterPress(fieldName)}
        {...props}
      />
    )
  }

  renderForm() {
    return (
      <FormCard
        component={CenteredCard}
        onSubmit={this.handleSubmit}
        title="Set new password"
        applyButton={<Button>Update password</Button>}
        cancelButton={<LinkButton to="/">Cancel</LinkButton>}
      >
        <CardContent>
          { this.renderField('password', {
            label: 'Password',
            innerRef: this.passwordInnerRef,
          }) }
          <Spacer />
          <Validator rule={this.validateConfirmPassword}>
            { passwordValidation => this.renderField('confirmPassword', {
              validation: passwordValidation,
              label: 'Confirm password',
              innerRef: this.confirmPasswordInnerRef,
              // @todo
              inputRef: this.confirmPasswordInputRef,
            }) }
          </Validator>
        </CardContent>
      </FormCard>
    )
  }

  renderPasswordReset() {
    return (
      <CenteredCard>
        <CardHeader title="Set new password" />
        <CardContent>
          <Typography>
            You've successfully changed the password to your account
          </Typography>
        </CardContent>
        <CardActions>
          <LinkButton size="small" color="secondary" to="/">
            Continue
          </LinkButton>
        </CardActions>
      </CenteredCard>
    )
  }

  render() {
    const { complete } = this.state
    return complete
      ? this.renderPasswordReset()
      : this.renderForm()
  }
}
